import { useState } from 'react';


        function CollapsiblePanel({ title, defaultOpen = false, right = null, children }) {
            const [open, setOpen] = useState(defaultOpen);
            return (
                <div className="mb-4">
                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom: open ? '14px' : '0', cursor:'pointer'}} onClick={() => setOpen(!open)}>
                        <div className="font-mono text-xs uppercase tracking-widest text-muted">
                            <span style={{marginRight:'8px', display:'inline-block', width:'10px'}}>{open ? '▾' : '▸'}</span>
                            {title}
                        </div>
                        {right}
                    </div>
                    {open && <div>{children}</div>}
                </div>
            );
        }

export { CollapsiblePanel };
